import { RootState } from '../store';

export const selectGalleryState = (state: RootState) => state.gallery;

export const selectGalleryItems = (state: RootState) => selectGalleryState(state).items;
export const selectGalleryLoading = (state: RootState) => selectGalleryState(state).loading;
export const selectGalleryError = (state: RootState) => selectGalleryState(state).error;
export const selectGalleryNextPageToken = (state: RootState) => selectGalleryState(state).nextPageToken;
export const selectGalleryFetched = (state: RootState) => selectGalleryState(state).fetched;
